const CHILD_SIGNIN_FORM_PREFIX = 'CHILD_SIGNIN';

export const childSignInFormName = (childId: string) => `${CHILD_SIGNIN_FORM_PREFIX}_${childId}`;

export const checkingInOutPersonType = (childId: string, rolesIds: string[]) => {
    return rolesIds.includes(childId) ? 'parent' : 'employee';
};
